window._ = require('lodash');
window.Popper = require('popper.js').default;


window.axios = require('axios');